import { render, staticRenderFns } from "./PumaPromoDetails.vue?vue&type=template&id=3d186664&"
import script from "./PumaPromoDetails.vue?vue&type=script&lang=js&"
export * from "./PumaPromoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports